import React from "react";

export default function AccountClose() {
  return (
    <div className="container-fluid maxContainerSection paddingTop">
      <div className="row commonPadding closeFormSectionOuter">
        <div className="col-md-6">
          <div className="closeFormSection">
            <h3 className="m-0 headerThree">Account closing form</h3>
            <div className="closeForm">
              <input type="text" placeholder="Enter your name" />
              <input type="email" placeholder="Enter your email" />
              <textarea type="text" placeholder="Enter note here" />
              <button className="submitBtn">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
